import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

// components
import Notification from '../../components/Notification/Notification.component'

// style components
import { ButtonsWrapper, Container, LogoutMobileButton } from './Profile.style'

// routes
import { NotificationType } from '../../types/notification.enum'
import { useLogout } from '../../hooks/useAuth'
import { useHistory } from 'react-router-dom'
import { homeRoute } from '../Home/route.const'
import ProfileButton from '../../components/ProfileButton/ProfileButton.component'
import { personalInfoRoute } from '../PersonalInfo/route.const'
import { myVehicleRoute } from '../MyVehicle/route.const'
import { helpRoute } from '../Help/route.const'
import { accountPaymentRoute } from '../AccountPayment/route.const'

const Profile: FC = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const logout = useLogout()

    const [showNotification] = useState<NotificationType | null>(null)

    const onLogoutClick = () => {
        logout()
        history.push(homeRoute())
    }

    return (
        <Container>
            <ButtonsWrapper>
                <ProfileButton
                    title={t('profile.personalInformation')}
                    route={personalInfoRoute()}
                    icon="wemolo-user"
                />
                <ProfileButton title={t('profile.payment')} route={accountPaymentRoute()} icon="wemolo-card-1" />
                <ProfileButton title={t('profile.myVehicle')} route={myVehicleRoute()} icon="wemolo-car-small" />
                <ProfileButton title={t('profile.help')} route={helpRoute()} icon="wemolo-heart" last />
            </ButtonsWrapper>
            <LogoutMobileButton onClick={onLogoutClick}>
                <i className={`wemolo-logout`} />
                <span>{t('profile.logout')}</span>
            </LogoutMobileButton>
            {showNotification && (
                <Notification type={showNotification} onClose={() => {}}>
                    {t(
                        showNotification === NotificationType.POSITIVE
                            ? 'profile.successfulRegistration'
                            : 'errors.errorOnSave'
                    )}
                </Notification>
            )}
        </Container>
    )
}

export default Profile
